import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import { Fragment, useContext, useState } from "react";
import DataContext from "../../context/data-context";
import { FaEdit, FaUserCircle } from "react-icons/fa";
import { AuthContext } from "../../context/auth-context";
import LoadingSpinner from "../UI/LoadingSpinner";
import { requestPartnerAPI } from "../../api/server";
import uploadFile from "../../util/uploadFile";
import SelectPair from "../UI/SelectPair";
import { isoDateToString } from "../../util/format-date";
import { MdCheck, MdClose } from "react-icons/md";
import WarningModal from "../UI/WarningModal";
import { toTitleCase } from "../../util/toTitleCase";

export default function Profile() {
  const { user } = useContext(AuthContext);
  const { partner, fetchData } = useContext(DataContext);

  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const editHandler = async () => {
    try {
      setLoading(true);
      const file = document.getElementById("Photo").files[0];
      const path = `partners/${user.uid}/photo`;
      let photoURL;
      if (file) photoURL = await uploadFile(path, file, setUploading);
      const data = {
        photo: photoURL,
      };
      await requestPartnerAPI("edit-partner", data);
      fetchData(() => {
        setLoading(false);
      });
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <div className="container">
      <Heading
        title="Profile"
        description={`The following information 
        cannot be changed because it is used in the 
        FAP Agreement.`}
      >
        <p className="text-sm text-stone-400">ID: {partner?.id}</p>
      </Heading>
      <div className="flex items-center my-8 space-x-4">
        <div className="w-20 h-20">
          {partner.photo && (
            <img src={partner.photo} className="rounded-full" />
          )}
          {user.photoURL && !partner.photo && (
            <img src={user.photoURL} className="rounded-full" />
          )}
          {!user.photoURL && !partner.photo && (
            <FaUserCircle className="w-full h-full text-yellow-600 cursor-pointer" />
          )}
        </div>

        <div className="grid gap-2 text-sm text-stone-200">
          <p className="text-xs text-stone-400">Change Profile Picture:</p>
          <input
            type="file"
            id="Photo"
            accept="image/*"
            onChange={editHandler}
          />
        </div>
      </div>

      <div className="info">
        <SelectPair
          options={[
            {
              name: "Individual",
              id: "individual",
            },
            {
              name: "Business",
              id: "business",
            },
          ]}
          label="Type"
          value={toTitleCase(partner.type)}
        />
        {partner.type === "business" ? (
          <Fragment>
            <DetailPair label="Business Name" value={partner.businessName} />
            <DetailPair label="Authorized Signatory" value={partner.name} />
            <DetailPair label="EIN" value={partner.ein} />
            <DetailPair
              label="Business Address"
              value={partner.businessAddress}
            />
          </Fragment>
        ) : (
          <DetailPair label="Name" value={partner.name} />
        )}
        <DetailPair label="Email" value={partner.email} />
        <DetailPair label="Phone" value={partner.phone} />
        <DetailPair label="Home Address" value={partner.address} />
        <DetailPair
          label="Date of Birth"
          value={isoDateToString(partner.dob)}
        />
      </div>
      {loading && (
        <div className="flex items-center mt-12 space-x-4">
          <LoadingSpinner />
          {uploading > 0 && (
            <p className="text-sm text-stone-400">Uploading: {uploading}%</p>
          )}
        </div>
      )}
    </div>
  );
}
